import { render, staticRenderFns } from "./Vitals.vue?vue&type=template&id=20a0b936&scoped=true&"
import script from "./Vitals.vue?vue&type=script&lang=js&"
export * from "./Vitals.vue?vue&type=script&lang=js&"
import style0 from "./Vitals.vue?vue&type=style&index=0&id=20a0b936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a0b936",
  null
  
)

export default component.exports